import { legacy_createStore as createStore, applyMiddleware } from "redux";
import { thunk } from "redux-thunk";
import reducer from "./reducers";

export const store = createStore(reducer, applyMiddleware(thunk));
